import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const containerRef = useRef(null);
  const prevLocationRef = useRef(location.pathname);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!containerRef.current) return;
    
    const isNewPage = prevLocationRef.current !== location.pathname;
    prevLocationRef.current = location.pathname;

    if (isNewPage) {
      queueMicrotask(() => setIsVisible(false));
      setTimeout(() => {
        setIsVisible(true);
      }, 50);
    }
  }, [location.pathname]);

  return (
    <div
      ref={containerRef}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
      }}
    >
      {children}
    </div>
  );
};

export default PageTransition;
